export const APP_NAME = 'MessageDrafts';
export const APP_VERSION = '1.1.12';

/** Canonical site URL for Open Graph and absolute asset URLs (e.g. preview image). */
export const SITE_URL = 'https://messagedrafts.com';
